export const BASE_PATH_URL = '/dashboard'
